import React, { useState } from "react";
import {
  Button,
  Typography,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { resetPassword } from "../../../services/Manage_service";
import { useAppDispatch } from "../../../services/StoreHooks";
import useTranslatewrapper from "../../../components/useTranslateWrapper";

function ResetPasswordModal(props) {
  const { id, setModalOpen, userName } = props;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const {translate} = useTranslatewrapper()

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);
  let msg = "";
  const passwordChangeHandler = (e) => {
    setPassword(e.target.value.trim());

    const capitalAndNumberRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).*$/;
    const specialCharacterRegex = /[\W_]+/;

    if (e.target.value.trim().length === 0) {
      document.getElementById("password-validate-message").innerHTML =
        "Password can not be Empty";
      document.getElementById("password-validate-message").style.color = "red";
    } else if (e.target.value.length < 8) {
      document.getElementById("password-validate-message").innerHTML =
        "Password must have at least 8 characters and must contain at least one uppercase letter, one lowercase letter, a special character and one number";
      document.getElementById("password-validate-message").style.color = "red";
    } else if (!capitalAndNumberRegex.test(e.target.value.trim())){
      document.getElementById("password-validate-message").innerHTML =
      "Password must contain at least one uppercase letter, one lowercase letter and one number";
      document.getElementById("password-validate-message").style.color = "red";
    }else if (!specialCharacterRegex.test(e.target.value.trim())){
      document.getElementById("password-validate-message").innerHTML =
      "Password must contain at least one special character";
      document.getElementById("password-validate-message").style.color = "red";
    } else if (confirmPassword && e.target.value.trim() !== confirmPassword) {
      document.getElementById("password-validate-message").innerHTML = "";
      document.getElementById("confirm-password-validate-message").innerHTML =
        "Passwords do not match";
      document.getElementById("confirm-password-validate-message").style.color =
        "red";
    } else {
      document.getElementById("password-validate-message").innerHTML = "";
      if(document.getElementById("confirm-password-validate-message").innerHTML == "Passwords do not match"){
        document.getElementById("confirm-password-validate-message").innerHTML = "";
      }
    }
  };

  const confirmPasswordChangeHandler = (e) => {
    setConfirmPassword(e.target.value.trim());
    if (e.target.value.trim().length === 0) {
      document.getElementById("confirm-password-validate-message").innerHTML =
        "Password can not be Empty";
      document.getElementById("confirm-password-validate-message").style.color =
        "red";
    } else if (e.target.value !== password) {
      document.getElementById("confirm-password-validate-message").innerHTML =
        "Passwords do not match";
      document.getElementById("confirm-password-validate-message").style.color =
        "red";
    } else {
      document.getElementById("confirm-password-validate-message").innerHTML =
        "";
    }
  };

  const dispatch = useAppDispatch();
  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const handlePasswordReset = async () => {
    if(document.getElementById("password-validate-message").innerHTML != "" || 
    document.getElementById("confirm-password-validate-message").innerHTML != "" || 
    password == "" || confirmPassword == null || confirmPassword==""){
      return;
    }
    const apiBody = {
      userId : parseInt(id),
      password : password,
      userName
    }

    const result = await resetPassword(id, apiBody);
    if (result.status === 200) {
      setModalOpen(false);
      dispatchNotification("success", [result.data]);
    }
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography sx={{ margin: 1 }} variant="h6">
        {translate('resetPassword')}
      </Typography>

      <FormControl variant="outlined" sx={{ width: "80%", my: 1 }}>
        <InputLabel htmlFor="outlined-adornment-password">{translate('password')}</InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          type={showPassword ? "text" : "password"}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          required
          label="Password"
          value={password}
          onChange={(e) => {
            passwordChangeHandler(e);
          }}
        />
        <FormHelperText id="password-validate-message">{msg}</FormHelperText>
      </FormControl>

      <FormControl variant="outlined" sx={{ width: "80%", my: 1 }}>
        <InputLabel htmlFor="outlined-adornment-password">
          {translate('confirmPassword')}
        </InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          type={showConfirmPassword ? "text" : "password"}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowConfirmPassword}
                edge="end"
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          label="Confirm Password"
          required
          value={confirmPassword}
          onChange={(e) => {
            confirmPasswordChangeHandler(e);
          }}
        />
        <FormHelperText id="confirm-password-validate-message">
          {msg}
        </FormHelperText>
      </FormControl>
      <Button
        type="submit"
        variant="contained"
        onClick={handlePasswordReset}
        sx={{ my: 2 }}
      >
        {translate('updatePassword')}
      </Button>
    </Box>
  );
}

export default ResetPasswordModal;
